import React from 'react';
import { useNavigate } from 'react-router-dom';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';

function MarketingEmailCampaignsPageView({ rows, search, isLoading, error, reload, setSearch }) {
  const navigate = useNavigate();

  return (
    <div>
      <FloatingAlerts error={error} />
      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>Marketing emails</h2>
          <p>Create native campaigns and track delivery metrics.</p>
        </div>
        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary" onClick={reload} disabled={isLoading}>
            Refresh
          </button>
          <button type="button" className="btn btn-primary" onClick={() => navigate('/marketing/emails/campaigns/new')}>
            <i className="ti ti-plus me-1"></i>Create campaign
          </button>
        </div>
      </div>

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <div className="row g-2 align-items-center mb-3">
            <div className="col-md-4">
              <input
                type="search"
                className="form-control"
                placeholder="Search campaigns"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
              />
            </div>
          </div>

          <LoadingContainer isLoading={isLoading} hasData={rows.length > 0}>
            <div className="table-responsive">
              <table className="table search-table align-middle text-nowrap mb-0">
                <thead className="header-item">
                  <tr>
                    <th>Name</th>
                    <th>Subject</th>
                    <th>Status</th>
                    <th>Selected</th>
                    <th>Queued</th>
                    <th>Sent</th>
                    <th>Failed</th>
                    <th>Skipped</th>
                    <th>Sent at</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && rows.length === 0 ? (
                    <tr><td colSpan="9" className="text-center text-muted">No campaigns found.</td></tr>
                  ) : null}
                  {rows.map((row) => (
                    <tr key={row.key} className="app-clickable-row" onClick={() => navigate(`/marketing/emails/campaigns/${encodeURIComponent(row.uid)}`)}>
                      <td className="fw-semibold">{row.name}</td>
                      <td>{row.subject}</td>
                      <td><span className={`badge rounded-pill fw-semibold text-uppercase ${row.statusBadgeClass}`}>{row.statusLabel}</span></td>
                      <td>{row.selectedCount}</td>
                      <td>{row.queuedCount}</td>
                      <td>{row.sentCount}</td>
                      <td>{row.failedCount}</td>
                      <td>{row.skippedCount}</td>
                      <td>{row.sentAtLabel}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default MarketingEmailCampaignsPageView;
